<template>
  <div class="create-page container">
    <div class="row">
      <div class="col-lg-12">
        <a href="account">
          <img class="logo" alt="Income logo" src="../assets/income.svg">
        </a>
        <div class="logout-section">
          <b-button class="menu-btn logout-btn" @click="logout">{{ $t('views.register.logout') }}</b-button>
        </div>
        <loader v-show="isLoading"/>
        <div v-if="!isLoading" >
          <stepper :steps="steps" @setstep="setStep"/>
          <div class="container create-account">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12" v-show="step===1">
                <div>
                  <div class="header-before-form">
                    <before-form-header :title="$t('views.register.createYourAccount')" :description="$t('views.register.createYourAccountDescription')"/>
                  </div>
                  <div class="stepper">
                    <ul>
                      <li :class="{'active':showIndividualForm}" id="individual" v-on:click="select">{{ $t('views.register.individual') }}</li>
                      <li :class="{'active':showCompanyForm}" id="company" v-on:click="select">{{ $t('views.register.company') }}</li>
                      <li class="empty-end">&nbsp;</li>
                    </ul>
                  </div>
                  <create-account v-show="showIndividualForm" :investorData=investor @setstep="setStep" @updateinvestor="updateInvestor" @readingAgreement="readAgreement"/>
                  <create-company-account v-show="showCompanyForm" :investorData=investor @setstep="setStep" @updateinvestor="updateInvestor" @readingAgreement="readAgreement"/>
                </div>
              </div>
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12" v-show="step===2">
                <investor-profile v-if="investor && !investor.investor_is_company" @setloading="setLoading" @updateinvestor="updateInvestor" @setstep="setStep"></investor-profile>
                <company-profile v-if="investor && investor.investor_is_company" @setloading="setLoading" @updateinvestor="updateInvestor" @setstep="setStep"></company-profile>
              </div>
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12" v-show="step===3">
                <before-form-header :title="$t('views.register.identity')" description=""/>
                <identity :investorData="investor" @setloading="setLoading" @updateinvestor="updateInvestor" @setstep="setStep"/>
              </div>
              <div class="col right-col" v-show="step!==5" v-bind:class="(step!==5 ? 'col-xl-4 col-lg-4 col-md-12 col-sm-12' : '')">
                <div class="w-100 text-center">
                  <info-block :step="step" :image="stepImage" :title="stepTitle" :description="stepDescription"></info-block>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stepper from '../components/Stepper'
import CreateAccount from '../components/CreateAccount'
import CreateCompanyAccount from '../components/CreateCompanyAccount'
import BeforeFormHeader from '../components/BeforeFormHeader'
import Identity from '../components/Identity'
import Loader from '../components/Loader'
import InfoBlock from '../components/InfoBlock'
import localStorageHelper from '../helpers/localStorageHelper'
import loadingMixin from '../mixins/loading'
import InvestorProfile from '@/components/InvestorProfile'
import CompanyProfile from '@/components/CompanyProfile'
import {investorStatuses, registrationStatuses} from '@/config/investorStatuses'

export default {
  components: {CompanyProfile, InvestorProfile, InfoBlock, Loader, Identity, CreateAccount, CreateCompanyAccount, Stepper, BeforeFormHeader},
  mixins: [loadingMixin],
  data()
  {
    return {
      showIndividualForm: true,
      showCompanyForm: false,
      step: 1,
      stepImage: 'account-protection.svg',
      stepTitle: 'views.register.accountProtection',
      stepDescription: 'views.register.stepDescription',
      steps: [
        {id: 1, title: 'views.register.personalDetails', active: true, completed: false, locked: false},
        {id: 2, title: 'views.register.investorProfile', active: false, completed: false, locked: true},
        {id: 3, title: 'views.register.identity', active: false, completed: false, locked: true}
      ],
      investor: null,
      isLoading: true,
      readingAgreement: false
    }
  },
  computed: {
    isLoaded: function ()
    {
      return this.loaded
    }
  },
  created()
  {
    this.onInvestorInit().then((investor) =>
    {
      this.investor = investor
    })
  },
  mounted()
  {
    this.$root.$emit('shownav', false)
    this.step = parseInt(localStorageHelper.get('register_step')) || 1
    this.isLoading = !this.isLoaded
    this.setAvailabilityOfLastSteps()
  },
  beforeDestroy()
  {
    this.$root.$emit('shownav', true)
  },
  watch: {
    isLoaded: function ()
    {
      this.isLoading = !this.isLoaded
      if (this.isLoaded)
      {
        this.setAvailabilityOfLastSteps()
      }
    },
    '$store.state.investors.investor': function (investor) {
      // This page allowed only for registrationStatuses
      if (investor && investor.investor_account_status)
      {
        if (!registrationStatuses.includes(investor.investor_account_status))
        {
          if (investor.investor_account_status === investorStatuses.APPROVED && investor.days_until_doc_expired && investor.days_until_doc_expired <= 30)
          {
            // skip hard redirect for approved but with investor.days_until_doc_expired <= 30
          }
          else
          {
            // console.log('This page allowed only for registrationStatuses', investor.investor_account_status)
            console.log('Hard redirect to account from register page :', investor.investor_account_status)
            this.$router.push('/account')
          }
        }
      }
      this.setAvailabilityOfLastSteps()
    },
    step: function (number)
    {
      // console.log('Set current step to: ' + number)
      // Validation, for now allowed 3 reg steps.
      if (number < 1 || number > 3)
      {
        this.step = number = 1
      }

      this.setAvailabilityOfLastSteps()

      // Show nav when go to invest page
      if (this.$router.currentRoute.path === '/register')
      {
        this.$root.$emit('shownav', false)
      }

      try
      {
        // Set completed previous steps
        this.steps.filter(s => s.id < number).forEach(function (step)
        {
          step.active = false
          step.completed = true
        })
        // Set not active/completed next elements
        this.steps.filter(s => s.id > number).forEach(function (step)
        {
          step.active = false
          step.completed = false
        })
        // Set active current selected step
        this.steps.filter(s => s.id === number).shift().active = true
        this.steps.filter(s => s.id === number).shift().locked = false
        localStorageHelper.set('register_step', number)
      }
      catch (e)
      {
        console.log('Something went wrong with changing steps', e)
      }
    }
  },
  methods: {

    onInvestorInit()
    {
      return new Promise((resolve, reject) =>
      {
        if (this.$store.state.investors.investor)
        {
          resolve(this.$store.state.investors.investor)
        }
        this.$watch(
            () =>
            {
              return this.$store.state.investors.investor
            },
            (investorData) =>
            {
              if (investorData)
              {
                resolve(investorData)
              }
            }
        )
      })
    },
    select: function (event)
    {
      const selectedRegisterType = event.currentTarget.id
      if (selectedRegisterType === 'individual')
      {
        this.showIndividualForm = true
        this.showCompanyForm = false
      }
      else if (selectedRegisterType === 'company')
      {
        this.showIndividualForm = false
        this.showCompanyForm = true
      }
    },
    setStep(number)
    {
      this.step = number
    },
    updateInvestor(investorData)
    {
      investorData = this.setInvestorPrefix(investorData) // After updated BE API we should to add 'investor_' prefix
      this.investor = {...this.$store.state.investors.investor, ...investorData}
      this.$store.dispatch('investors/updateInvestor', this.investor)
    },
    setInvestorPrefix(investorData)
    {
      const objectWithPrefix = {}
      if (investorData)
      {
        for (const propertyName in investorData)
        {
          const propertyNameWithPrefix = 'investor_' + propertyName
          objectWithPrefix[propertyNameWithPrefix] = investorData[propertyName]
        }
      }
      return objectWithPrefix
    },
    setLoading(loading)
    {
      this.isLoading = loading
    },
    readAgreement(reading)
    {
      if (reading)
      {
        this.$root.$emit('showuseragreement', true)
      }
    },
    setAvailabilityOfLastSteps()
    {
      const investorStatus = this.getInvestorStatus()
      switch (investorStatus)
      {
        case investorStatuses.EMAIL_VERIFIED:
          this.setStep(1)
          break
        case investorStatuses.CONTACTS_FILLED:
          this.steps[0].completed = this.steps[0].locked = true
          this.setStep(2)
          break
        case investorStatuses.PROFILE_FILLED:
        case investorStatuses.INVESTMENT_SUSPENDED:
          this.steps[0].completed = this.steps[0].locked = this.steps[1].completed = this.steps[1].locked = true
          this.setStep(3)
          break
        case investorStatuses.APPROVED:
            if (this.investor && this.investor.days_until_doc_expired && this.investor.days_until_doc_expired <= 30)
            {
              this.setStep(3)
            } else {
              console.log('Hard redirect to account from case on register page :', investorStatus)
              this.$router.push('/account')
            }
          break
        default:
          console.log('Hard redirect to account from case on register page :', investorStatus)
         this.$router.push('/account')
        break
      }
    },
    getInvestorStatus()
    {
      let investorStatus = investorStatuses.EMAIL_VERIFIED
      if (this.investor && this.investor.investor_account_status) {
        investorStatus = this.investor.investor_account_status
      }
      return investorStatus
    },
    isFinishedFirstStep()
    {
      return (this.investor && this.investor.investor_first_name)
    },
    isFinishedSecondStep()
    {
      return (this.investor && ((this.investor.investor_identity_status && this.investor.investor_identity_status === 'approved') || this.isKYC()))
    },
    isFinishedThirdStep()
    {
      return (this.investor && this.investor.investor_other_info && this.investor.investor_other_info !== '{}')
    },
    logout()
    {
      this.$auth.logout({
        returnTo: window.location.origin + '/logout'
      })
    }
  }
}
</script>

<style lang="scss" scoped>

h3 {
  font-size: 45px;
  line-height: 45px;
}

.logo{
  max-width: 110px;
}

.create-page {
  .create-account {
    margin: 45px 0 0 23px;
  }

  .right-col {
    border-radius: 4px;
    min-height: 359px;
    text-align: center;

    h4 {
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      font-feature-settings: 'liga' off;
      color: #000000;
    }

    img {
      padding-top: 5px
    }
  }
}

.stepper {
  width: 100%;
  display: block;
  margin: 20px auto 20px 3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  ul > li {
    display: inline-block;
    zoom: 1;
    *display: inline;
    padding-right: 25px;
    padding-left: 5px;
    border-bottom: 3px solid #EDEFF2;
    cursor: pointer;
  }

  ul {
    padding-inline-start: 0;
    width: 100%;
    display: inline-flex;
  }

  @media (max-width: 510px) {
    ul {
      display: inline-grid;
    }
  }

  .active {
    color: #30A7FE;
    text-decoration: none;
    font-weight: bold;
    border-bottom: 3px solid #30A7FE;
  }

  .completed {
    opacity: 0.4;
    color: #30A7FE;
    border-bottom: 3px solid #30A7FE;
  }

  .empty-end {
    width: 100%;
    overflow: auto;
    display: inline;
    cursor: default;
  }
}

.card-deck {
  margin-bottom: 40px;
}

@media only screen and (max-width: 1024px) {
  .create-page .create-account {
    margin: 0;
  }
}

.logout-btn {
  text-align: left;

  img {
    width: 22px;
  }
}

.menu-btn {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  color: #000000;
  mix-blend-mode: normal;
  opacity: 0.8;
  background-color: transparent;
  border: none;
  margin: 5px 25px;
}

.logout-section {
  display: inline-block;
  float: right;
  margin-top: 5px;
}
</style>
<style>
.register-btn {
  float: right;
  background: #30A7FE;
  border-radius: 24px;
  border-color: transparent;
  min-width: 200px;
}

.name-field, .ca-field {
  height: 48px;
}

.toggle-password {
  display: inline-block;
  width: 24px;
  float: left;
  margin-left: -35px;
  margin-top: 11px;
  cursor: pointer;
}

.password {
  float: left;
}

.password-area {
  width: 100%;
  min-height: 40px;
}

.confirm-agreement {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.first-inline-field {
  float: left;
  display: inline-block;
  margin-right: 20px;
}

@media (max-width: 992px) {
  .register-btn {
    float: none;
    width: 100%;
    margin-bottom: 20px;
    padding: 5px;
  }
}

@media (max-width: 400px) {
  .first-inline-field {
    margin-right: 0;
    float: none;
  }
}

.second-inline-field {
  float: left;
  display: inline-block;
}

.inline-group {
  width: 100%;
  clear: both;
  display: inline-flex;
}

.country-flag {
  max-width: 30px;
  margin-right: 10px;
  border: 1px solid #eaecf0;
}

.form-field {
  height: 48px;
}

.skip {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #30A7FE;
}

.agreement-link {
  color: #30A7FE !important;
  cursor: pointer;
}

.skip-btn, .skip-btn:hover {
  box-shadow: none !important;
  background: none !important;
  border: none !important;
  color: #30A7FE;
  padding-left: 0;
}
</style>
